/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Beschaefitgungslosleistungsbezug1Inputs */



/**

* @param {_Field_Beschaefitgungslosleistungsbezug1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_beschaefitgungslosleistungsbezug1 = /** @type {((inputs?: _Field_Beschaefitgungslosleistungsbezug1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Beschaefitgungslosleistungsbezug1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Leistungsbezug der Agentur für Arbeit")
});
export { _field_beschaefitgungslosleistungsbezug1 as "_field_beschaefitgungslosLeistungsbezug" }